/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ColumnChartProps } from '../../ColumnChart.props';

export const getColumnChartAxisOptions = (options: ColumnChartProps): Highcharts.Options => {
  const { xAxisLabel, yAxisLabel, categories, minX, maxX, tickMarks, showGrid, boldLines } = options;
  return {
    xAxis: {
      ...(minX && { min: minX }),
      ...(maxX && { max: maxX }),
      ...(tickMarks && {
        startOnTick: false,
        tickLength: 10,
        tickmarkPlacement: 'on',
        tickPosition: 'outside',
        tickWidth: boldLines ? 1.5 : 1,
      }),
      ...(boldLines && {
        gridLineColor: '#ccc',
        lineColor: '#000',
        lineWidth: 1.5,
        tickColor: '#000',
      }),
      categories,
      gridLineWidth: showGrid ? 1 : 0,

      labels: {
        style: {
          fontWeight: boldLines ? 'bold' : 'normal',
        },
      },
      title: {
        text: xAxisLabel,
        useHTML: true,
      },
    },
    yAxis: {
      ...(tickMarks && {
        startOnTick: false,
        tickLength: 10,
        tickmarkPlacement: 'on',
        tickPosition: 'outside',
        tickWidth: boldLines ? 1.5 : 1,
      }),
      ...(boldLines && {
        gridLineColor: '#ccc',
        lineColor: '#000',
        lineWidth: 1.5,
        tickColor: '#000',
      }),
      labels: {
        style: {
          fontWeight: boldLines ? 'bold' : 'normal',
        },
      },
      min: 0,
      title: {
        text: yAxisLabel,
        useHTML: true,
      },
    },
  };
};
